import api from './api'

// Typed client for the Tasks (taskboards) module's SERVER-scope admin
// dashboard ("board / task stats").
// Server: @os/taskboards server/lib/taskboardsAdminAggregate.ts +
// server/routes/admin.ts, surfaced at GET /taskboards/admin/stats
// (admin-gated, scoped to one server via ?serverId=). Read-only.
//
// These shapes MUST stay field-for-field in sync with the server's
// TaskboardsAdminStats output (taskboardsAdminAggregate.ts). All dates are
// ISO strings, or null where the underlying fact has never happened yet.

export interface TaskboardsAdminKpis {
  totalBoards: number
  departmentBoards: number
  personalBoards: number
  archivedBoards: number
  activeTasks: number
  overdueTasks: number
}

export interface TaskboardsAdminBoard {
  id: string
  name: string
  visibility: string
  archived: boolean
  taskCount: number
  lastActivityAt: string | null
}

export interface TaskboardsAdminStats {
  serverId: string
  generatedAt: string
  kpis: TaskboardsAdminKpis
  statusBreakdown: { todo: number; inProgress: number; done: number }
  boards: TaskboardsAdminBoard[]
}

// OSPROD-191: NEW-ticket counts for the current user — total (Tasks sidebar
// badge) + per board (board-list counter). NEW = unassigned + non-done.
export interface TaskboardsNewCounts {
  total: number
  byBoard: Record<string, number>
}

export const taskboardsApi = {
  // Read-only board/task stats for the SERVER "Tasks" module admin section.
  // Server gates this to admins and scopes it to the given server.
  adminServerStats: (serverId: string) =>
    api.get<TaskboardsAdminStats>(
      `/taskboards/admin/stats?serverId=${encodeURIComponent(serverId)}`,
    ),

  // OSPROD-191: the current user's NEW-ticket counts (sidebar badge + per-board).
  newCounts: () => api.get<TaskboardsNewCounts>('/taskboards/items/new-counts'),
}
